import { ParametriOpzionaliDocumento } from "../fascicolo/parametri-opzionali-documento";

export class AssociativeOpzioniDocumento extends ParametriOpzionaliDocumento {

  static createOption(parametriOpzionaliDocumento: ParametriOpzionaliDocumento): AssociativeOpzioniDocumento {
    let newList = new ParametriOpzionaliDocumento();
    if (parametriOpzionaliDocumento.id) {
      newList.id = parametriOpzionaliDocumento.id;
    }
    newList.parametro = parametriOpzionaliDocumento.parametro;
    newList.valore = parametriOpzionaliDocumento.valore;

    return newList;
  }
}
